import { Workflow } from "lucide-react";
import type { INavItem } from "@/models/INavItem";
import { EmailAutomationRoutes } from "./routes";
import { EmailAutomationPermissions } from "./permissions";

export const emailAutomationNav: INavItem = {
  labelKey: "nav.email_automations",
  icon: Workflow,
  path: EmailAutomationRoutes.LIST,
  permissions: [EmailAutomationPermissions.READ],
  permissionPrefix: "Travel:EmailAutomations:",
  children: [
    {
      labelKey: "nav.email_automations_manage",
      path: EmailAutomationRoutes.LIST,
      permissions: [EmailAutomationPermissions.READ],
    },
  ],
};
